import React, { FC } from 'react';
import styled from 'styled-components';
import { ICON_FILTER_ABLE, ICON_FILTER_DISABLE } from 'assets/icons';
import CommonImage from './CommonImage';
import Row from './Row';

const FilterButton = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0px;
  border-radius: 999px;
  background-color: #fff;
  color: ${props => (props.$isSelected ? '#0071E9' : '#70737C')};

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.6px;
`;

interface Props {
  isAcceptFilter: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
}

const CommonFilter: FC<Props> = props => {
  const { isAcceptFilter, onClick, style } = props;

  return (
    <Row gap="8px" style={style}>
      <FilterButton $isSelected={isAcceptFilter} onClick={onClick}>
        <CommonImage
          src={isAcceptFilter ? ICON_FILTER_ABLE : ICON_FILTER_DISABLE}
        />
        <span>{isAcceptFilter ? '필터 적용' : '필터'}</span>
      </FilterButton>
    </Row>
  );
};

export default CommonFilter;
